import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import EnterpriseAccountListRepository from '../../../repository/account-list/enterprise-account-list';
import { Entity } from '../../../../base/ddd-types/entity';
import { INetworkRequestService } from '../../../../base/request/network-request.interface';
var EnterpriseAccountListEntity = /** @class */ (function (_super) {
    __extends(EnterpriseAccountListEntity, _super);
    function EnterpriseAccountListEntity(networkRequestService, tinyId) {
        var _this = _super.call(this, tinyId) || this;
        _this.networkRequestService = networkRequestService;
        _this.enterpriseAccountListRepository = new EnterpriseAccountListRepository(networkRequestService);
        _this.enterpriseAccountList = [];
        return _this;
    }
    EnterpriseAccountListEntity.prototype.getEnterpiseAccountList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enterpriseAccountListRepository.getEnterpriseAccountList()];
                    case 1:
                        resData = (_a.sent()).resData;
                        this.enterpriseAccountList = (resData === null || resData === void 0 ? void 0 : resData.data.data) ? resData.data.data : [];
                        return [2 /*return*/, this.enterpriseAccountList];
                }
            });
        });
    };
    EnterpriseAccountListEntity.prototype.getUserMarkNameListByUids = function (uids) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enterpriseAccountListRepository.getUserMarkNameListByUids(uids)];
                    case 1:
                        resData = (_a.sent()).resData;
                        this.userMarkNameList = (resData === null || resData === void 0 ? void 0 : resData.data.data) ? resData.data.data : [];
                        return [2 /*return*/, this.userMarkNameList];
                }
            });
        });
    };
    EnterpriseAccountListEntity.prototype.delEnterpriseAccountForList = function (weSid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enterpriseAccountListRepository.delEnterpriseAccountForList(weSid)];
                    case 1:
                        _a.sent();
                        this.updateEntrepriseAccountListAfterDel(weSid);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    EnterpriseAccountListEntity.prototype.updateEntrepriseAccountListAfterDel = function (weSid) {
        this.enterpriseAccountList = this.enterpriseAccountList
            .filter(function (account) { return account.cookie.wedocSid !== weSid && account.cookie.wedriveSid !== weSid; });
    };
    EnterpriseAccountListEntity = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String])
    ], EnterpriseAccountListEntity);
    return EnterpriseAccountListEntity;
}(Entity));
export default EnterpriseAccountListEntity;
